import React from "react";

const NAKSHATRA = "/branding/nakshatra-logo.png";
const QREWHR = "/qrewhr-logo.png";

// Real Nakshatra logo. On dark surfaces it sits on a white plate so the navy wordmark stays legible.
export function Logo({ onLight = false, className = "", height = 34 }) {
  const img = (
    <img
      src={NAKSHATRA}
      alt="Nakshatra Housekeeping Services"
      style={{ height, width: "auto", objectFit: "contain", display: "block" }}
      data-testid="app-logo"
    />
  );
  if (onLight) return <div className={className}>{img}</div>;
  return (
    <div className={`bg-white rounded-md px-2.5 py-1.5 inline-flex w-fit self-start ${className}`} data-testid="app-logo-wrap">
      {img}
    </div>
  );
}

export function QrewHrLogo({ height = 18, className = "" }) {
  return (
    <img
      src={QREWHR}
      alt="QrewHR"
      style={{ height, width: "auto", objectFit: "contain" }}
      className={className}
      data-testid="qrewhr-logo"
    />
  );
}
